import { RadioGroupField } from './RadioGroupField';

export const YesNoRadioGroupField = ({ name, title, onChange, tooltip }: YesNoRadioGroupFieldProps) => {
  return RadioGroupField({
    name,
    onChange,
    title,
    options: [
      { label: 'Oui', value: true },
      { label: 'Non', value: false },
    ],
    tooltip,
  });
};

interface YesNoRadioGroupFieldProps {
  name: string;
  title: string;
  onChange?: (value: string) => void;
  tooltip?: string;
}
